import React from 'react';
import styled, { css } from 'styled-components';

const HeaderLarge: React.FCC = ({ children }) => (
  <Container>{children}</Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    padding: ${theme.space('m')};
    background-color: ${theme.color('white')};
    border-top-right-radius: ${theme.getTokens().border.radius.m};
    border-top-left-radius: ${theme.getTokens().border.radius.m};
  `,
);

export default HeaderLarge;
